import { EmailTemplateFooter } from "./EmailTemplateFooter";
import { EmailTemplateHeader } from "./EmailTemplateHeader";
import { RenderArtistOfTheMonth, RenderFeaturedOpenCall, RenderOpenCall } from "./RenderOpenCall";

function encodeImageUrl(url) {
    return url.replace(/ /g, "%20"); // Replace spaces with %20
}

// Function to generate SEO-friendly slug
function generateSlug(name) {
    return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

export const Template1 = ({ users = [], organizations = [], subscribers = [], customContent = "" }) => (
    <div style={{ backgroundColor: '#EFEFEF', borderRadius: '8px', overflow: 'hidden', textAlign: 'center' }}>
        {/* Header */}
        <EmailTemplateHeader
            title="Have a look on your competitors!"
            description="I am excited to share a specially curated list of amazing artists, organizations and subscribers for artists and organizations like you! Review their profiles and increase your interest to compete with them."
        />
        <h1 style={{ color: "#2c5282", fontSize: "24px", fontWeight: "bold", marginBottom: "20px", marginTop: '40px' }}>
            Recently Joined Artists, Organizations and Subscribers!
        </h1>
        <p style={{ color: "#4a5568", fontSize: "14px", marginBottom: "20px" }}>
            I am excited to bring you our latest curated list of artists and organizations just to keep you updated with your competitors.
        </p>

        {/* Custom content */}
        <div dangerouslySetInnerHTML={{ __html: customContent }} />

        {/* Organizations Section */}
        {organizations.length > 0 && (
            <div style={{ width: '90%', marginTop: "20px", tableLayout: 'fixed', margin: '0 auto' }}>
                <h2 style={{ color: "#38a169", fontSize: "24px", fontWeight: "bold", marginBottom: "16px" }}>Recently Joined Organizations</h2>
                <p>Review profiles of your competitors, If you are an organization.</p>
                <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
                    {organizations.map(org => (
                        <div key={org.email} style={{ textAlign: "center", width: "100%", backgroundColor: "#ffffff", borderRadius: "8px", padding: "20px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginBottom: '60px', paddingBottom: '50px' }}>
                            <img src={encodeImageUrl(org.featured_image)} alt={org.title} style={{ width: '100%', height: '350px', objectFit: 'fit', borderRadius: '8px 8px 0 0' }} />
                            <h3 style={{ fontSize: "18px", fontWeight: 'bold', color: "#2d3748", marginBottom: "12px", marginTop: "40px" }}>{org.organization_title}</h3>
                            <a href={`https://opencallforartists.com/users/organization/${org.id}-${generateSlug(`${org.organization_title}`)}`} style={{ color: "#ffffff", backgroundColor: "#38a169", padding: "8px 12px", borderRadius: "4px", textDecoration: "none", display: "inline-block" }}>
                                View Profile
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        )}

        {/* Users Section */}
        {users.length > 0 && (
            <div style={{ width: '90%', marginTop: "20px", tableLayout: 'fixed', margin: '0 auto' }}>
                <h2 style={{ color: "#38a169", fontSize: "24px", fontWeight: "bold", marginBottom: "16px" }}>Recently Joined Artists</h2>
                <p>Review profiles of your competitors, If you are an artist.</p>
                <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
                    {users.map(user => (
                        <div key={user.email} style={{ textAlign: "center", width: "100%", backgroundColor: "#ffffff", borderRadius: "8px", padding: "20px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginBottom: '60px', paddingBottom: '50px' }}>
                            <img src={encodeImageUrl(user.profile_picture)} alt={user.title} style={{ width: '100%', height: '350px', objectFit: 'fit', borderRadius: '8px 8px 0 0' }} />
                            <h3 style={{ fontSize: "18px", fontWeight: 'bold', color: "#2d3748", marginBottom: "12px", marginTop: "40px" }}>{user.title}</h3>
                            <a href={`https://opencallforartists.com/users/user/${user.id}-${generateSlug(`${user.title}`)}`} style={{ color: "#ffffff", backgroundColor: "#38a169", padding: "8px 12px", borderRadius: "4px", textDecoration: "none", display: "inline-block" }}>
                                View Profile
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        )}

        {/* Subscribers Section */}
        {subscribers.length > 0 && (
            <div style={{ width: "90%", marginTop: "20px", padding: "20px", textAlign: "center", margin: "0 auto" }}>
                <h2 style={{ color: "#38a169", fontSize: "24px", fontWeight: "bold", marginBottom: "16px" }}>New Subscribers</h2>
                <p>Have a look on our latest subscribers!</p>
                <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
                    {subscribers.map(subscriber => (
                        <div key={subscriber.email} style={{ textAlign: "center", width: "100%", padding: "10px", marginBottom: '10px' }}>
                            <h3 style={{ fontSize: "14px", color: "#2d3748", backgroundColor: "#ffffff", borderRadius: "8px", padding: "20px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", }}>{subscriber.email}</h3>
                        </div>
                    ))}
                </div>
            </div>
        )}

        {/* Footer */}
        <EmailTemplateFooter />
    </div>
);

export const Template2 = ({ openCalls = {}, reviews = [], customContent = "" }) => {
    return (
        <div style={{ backgroundColor: '#EFEFEF', borderRadius: '8px', overflow: 'hidden' }}>
            {/* Header */}
            <EmailTemplateHeader
                title="Explore Open Calls, Jobs & Residencies!"
                description="I am excited to bring you our latest curated list of opportunities designed just for artists like you! Whether you're on the hunt for open calls, jobs, or residencies, explore and apply to elevate your creative journey."
            />

            {/* Content Body */}
            <table width="100%" cellPadding="20" cellSpacing="0" style={{ tableLayout: 'fixed' }}>
                <tbody>
                    <tr>
                        <td>
                            {/* Custom content */}
                            <div style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }}>
                                <div dangerouslySetInnerHTML={{ __html: customContent }} />
                            </div>

                            {/* Render open calls */}
                            {openCalls.deadline_expires_soon && RenderOpenCall('Ending Soon, Submit Before Deadline!', openCalls.deadline_expires_soon, 'template_deadline_exprires_soon')}
                            {/* Render the specific open call */}
                            {openCalls.recently_added && RenderOpenCall('NEW IN: New Calls Added This Week!', openCalls.recently_added, 'template_recently_added')}
                            {/* Render the specific open call */}
                            {openCalls.most_viewed && RenderOpenCall('Popular Open Calls Amongst Artists!', openCalls.most_viewed, 'template_most_viewed')}         


                            {/* Reviews */}
                            {reviews.length > 0 && (
                                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                                    <h2 style={{ color: '#38a169', fontSize: '24px', fontWeight: 'bold' }}>Latest Reviews</h2>
                                    <p style={{ marginBottom: '20px' }}>Gain insights from fellow artists with these reviews:</p>
                                    <table width="90%" cellPadding="10" cellSpacing="0" border="0" style={{ margin: '0 auto' }}>
                                        <tbody>
                                            {reviews.map(review => (
                                                <tr key={review.id}>
                                                    <td style={{ backgroundColor: '#ffffff', padding: '16px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)', textAlign: 'center', marginBottom: '40px' }}>
                                                        <p>{review.review}</p>
                                                        <span style={{ color: '#000000', fontSize: '18px', fontWeight: 'bold' }}>{review.name}</span>
                                                        <div style={{ marginTop: '10px', fontWeight: '600' }}>
                                                            {/* Display stars based on ratings */}
                                                            {Array.from({ length: 5 }, (v, i) => (
                                                                <span key={i} style={{ color: i < review.ratings ? '#f1c40f' : '#e0e0e0', fontSize: '18px' }}>
                                                                    &#9733;
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* Footer */}
            <EmailTemplateFooter />
        </div>
    );
};

export const Template3 = ({ openCalls = {}, customContent = "" }) => {
    return (
        <div style={{ backgroundColor: '#EFEFEF', borderRadius: '8px', overflow: 'hidden' }}>
            {/* Header */}
            <EmailTemplateHeader
                title="Explore Open Calls, Jobs & Residencies!"
                description="I am excited to bring you our latest curated list of opportunities designed just for artists like you! Whether you're on the hunt for open calls, jobs, or residencies, explore and apply to elevate your creative journey."
            />

            {/* Content Body */}
            <table width="100%" cellPadding="20" cellSpacing="0" style={{ tableLayout: 'fixed' }}>
                <tbody>
                    <tr>
                        <td>
                            {/* Custom content */}
                            <div style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }}>
                                <div dangerouslySetInnerHTML={{ __html: customContent }} />
                            </div>

                            {/* Render the specific open call */}
                            {openCalls.deadline_expires_soon && RenderOpenCall('Ending Soon, Submit Before Deadline!', openCalls.deadline_expires_soon, 'template_deadline_exprires_soon')}
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* Footer */}
            <EmailTemplateFooter />
        </div>
    );
};

export const Template4 = ({ openCalls = {}, customContent = "" }) => {
    return (
        <div style={{ backgroundColor: '#EFEFEF', borderRadius: '8px', overflow: 'hidden' }}>
            {/* Header */}
            <EmailTemplateHeader
                title="Explore Open Calls, Jobs & Residencies!"
                description="I am excited to bring you our latest curated list of opportunities designed just for artists like you! Whether you're on the hunt for open calls, jobs, or residencies, explore and apply to elevate your creative journey."
            />

            {/* Content Body */}
            <table width="100%" cellPadding="20" cellSpacing="0" style={{ tableLayout: 'fixed' }}>
                <tbody>
                    <tr>
                        <td>
                            {/* Custom content */}
                            <div style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }}>
                                <div dangerouslySetInnerHTML={{ __html: customContent }} />
                            </div>
                            {/* Render the specific open call */}
                            {openCalls.recently_added && RenderOpenCall('NEW IN: New Calls Added This Week', openCalls.recently_added, 'template_recently_added')}
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* Footer */}
            <EmailTemplateFooter />
        </div>
    );
};

export const Template5 = ({ openCalls = {}, customContent = "" }) => {
    return (
        <div style={{ backgroundColor: '#EFEFEF', borderRadius: '8px', overflow: 'hidden' }}>
            {/* Header */}
            <EmailTemplateHeader
                title="Explore Open Calls, Jobs & Residencies!"
                description="I am excited to bring you our latest curated list of opportunities designed just for artists like you! Whether you're on the hunt for open calls, jobs, or residencies, explore and apply to elevate your creative journey."
            />

            {/* Content Body */}
            <table width="100%" cellPadding="20" cellSpacing="0" style={{ tableLayout: 'fixed' }}>
                <tbody>
                    <tr>
                        <td>
                            {/* Custom content */}
                            <div style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }}>
                                <div dangerouslySetInnerHTML={{ __html: customContent }} />
                            </div>
                            {/* Render the specific open call */}
                            {openCalls.most_viewed && RenderOpenCall('Popular Open Calls Amongst Artists!', openCalls.most_viewed, 'template_most_viewed')}
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* Footer */}
            <EmailTemplateFooter />
        </div>
    );
};

export const Template6 = ({ openCalls = {}, customContent = "" }) => {
    return (
        <div
            style={{
                backgroundColor: '#EFEFEF',
                borderRadius: '8px',
                overflow: 'hidden',
                fontFamily: 'Arial, sans-serif',
            }}
        >
            {/* Header */}
            <EmailTemplateHeader
                title="Explore Open Calls, Jobs & Residencies!"
                description="I am excited to bring you our latest curated list of opportunities designed just for artists like you! Whether you're on the hunt for open calls, jobs, or residencies, explore and apply to elevate your creative journey."
            />

            {/* Content Body */}
            <table
                width="100%"
                cellPadding="20"
                cellSpacing="0"
                style={{ tableLayout: 'fixed' }}
            >
                <tbody>
                    <tr>
                        <td style={{ textAlign: 'center' }}>
                            <h2
                                style={{
                                    color: '#2D3748',
                                    fontSize: '24px',
                                    fontWeight: 'bold',
                                    marginBottom: '15px',
                                }}
                            >
                                Featured Open Call: Curated just for artists like you!
                            </h2>

                            {/* Custom content */}
                            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: customContent,
                                    }}
                                />
                            </div>

                            {/* Render the specific open call */}
                            {openCalls.id && RenderFeaturedOpenCall(openCalls, 'template_featured_open_call')}
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* Footer */}
            <EmailTemplateFooter />
        </div>
    );
};

export const Template7 = ({ artistOfTheMonth = {}, customContent = "" }) => {
    return (
        <div style={{ backgroundColor: '#EFEFEF', borderRadius: '8px', overflow: 'hidden' }}>
            {/* Header */}
            <EmailTemplateHeader
                title="Meet the art icons of this month ready to shine in the art world."
                description="Here is our pick(s) for the art icons chosen by our team of experts and art lovers. Want to be the next art star of the month?"
            />

            {/* Content Body */}
            <table width="100%" cellPadding="20" cellSpacing="0" style={{ tableLayout: 'fixed' }}>
                <tbody>
                    <tr>
                        <td>
                            {/* Custom content */}
                            <div style={{ marginTop: '20px', marginBottom: '20px', textAlign: 'center' }}>
                                <div dangerouslySetInnerHTML={{ __html: customContent }} />
                            </div>
                            {/* Render the specific open call */}
                            {artistOfTheMonth && RenderArtistOfTheMonth('Next you can be "Artist Of The Month" like them!', artistOfTheMonth)}
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* Footer */}
            <EmailTemplateFooter />
        </div>
    );
};
